import script from "./Home.vue?vue&type=script&lang=ts&setup=true"
export * from "./Home.vue?vue&type=script&lang=ts&setup=true"

import "./Home.vue?vue&type=style&index=0&id=59f2126c&lang=scss&scoped=true"

import exportComponent from "D:\\桌面\\quotesystem\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59f2126c"]])

export default __exports__